import { CustomerContextConsumer } from "../../../Context/CustomerContext";
import CreateOffice365Asset from "./createOffice365Asset";

export const CreateOffice365AssetWrapper = () => (
  <CustomerContextConsumer>{() => <CreateOffice365Asset />}</CustomerContextConsumer>
);
